import { ReportBASalesDetailComponent } from './sales-detail.component';

export default ReportBASalesDetailComponent;
